import React, { useState } from 'react';
import { authorApi } from '@/features/workspace/api';

interface AIModalProps {
  onClose: () => void;
}

export const AuthorAIModal: React.FC<AIModalProps> = ({ onClose }) => {
  const [prompt, setPrompt] = useState('');
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState<Array<{ role: 'user' | 'ai'; text: string; suggestions?: string[] }>>([
    {
      role: 'ai',
      text: 'Здравствуйте, Сырым! Я академический ассистент модуля «Автор / Соавтор». Готов помочь с подбором журнала Scopus/WoS, проверкой структуры статьи по IMRAD, расчетом авторских долей или подготовкой ответа рецензентам.',
      suggestions: [
        'Подобрать журнал Scopus Q2 по педагогике',
        'Как оформить соавторство с зарубежным ученым?',
        'Какие документы нужны для 3-қосымша?',
        'Помочь составить ответ на замечания рецензента',
      ],
    },
  ]);

  const handleSend = async (textToSend?: string) => {
    const queryText = textToSend || prompt;
    if (!queryText.trim() || loading) return;

    setHistory((prev) => [...prev, { role: 'user', text: queryText }]);
    setPrompt('');
    setLoading(true);

    try {
      const response = await authorApi.aiQuery(queryText, 'author_cabinet');
      setHistory((prev) => [
        ...prev,
        {
          role: 'ai',
          text: response.answer,
          suggestions: response.suggested_actions,
        },
      ]);
    } catch {
      setHistory((prev) => [
        ...prev,
        {
          role: 'ai',
          text: 'Извините, возникла сетевая ошибка при обращении к академической нейросети. Попробуйте повторить запрос.',
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cab-overlay" role="dialog" aria-modal="true">
      <div className="cab-shell cab-shell--wide cab-shell--tall">
        <div className="cab-top">
          <div className="cab-top-left">
            <div>
              <small>Научный консультант</small>
              <h2>Научный AI-Консультант</h2>
              <p>Scopus, WoS, КОКСНВО и академический копирайтинг</p>
            </div>
          </div>
          <div className="cab-top-actions">
            <button type="button" className="cab-btn icon" onClick={onClose} aria-label="Закрыть">
              ✕
            </button>
          </div>
        </div>

        <div className="cab-body">
          <div className="cabinet-stack" style={{ maxHeight: 420, overflowY: 'auto' }}>
            {history.map((msg, i) => (
              <article
                key={i}
                className="cabinet-card"
                style={{
                  ['--accent' as string]: msg.role === 'user' ? '#41d2ff' : '#8faebb',
                  marginLeft: msg.role === 'user' ? 24 : 0,
                  marginRight: msg.role === 'ai' ? 24 : 0,
                }}
              >
                <strong style={{ fontSize: 12 }}>{msg.role === 'user' ? 'Вы' : 'Ассистент'}</strong>
                <p style={{ margin: '8px 0 0', fontSize: 13, lineHeight: 1.55, whiteSpace: 'pre-line' }}>
                  {msg.text}
                </p>
                {msg.suggestions && msg.suggestions.length > 0 ? (
                  <div className="cabinet-actions" style={{ marginTop: 10, flexWrap: 'wrap' }}>
                    {msg.suggestions.map((s, idx) => (
                      <button key={idx} type="button" className="cabinet-btn" onClick={() => handleSend(s)}>
                        {s}
                      </button>
                    ))}
                  </div>
                ) : null}
              </article>
            ))}
            {loading ? <div className="cabinet-note">Нейросеть формирует академический ответ…</div> : null}
          </div>

          <div className="cabinet-actions" style={{ marginTop: 14, alignItems: 'center' }}>
            <input
              type="text"
              className="cabinet-input"
              style={{ flex: 1 }}
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleSend();
              }}
              placeholder="Задайте вопрос научному ассистенту..."
            />
            <button
              type="button"
              className="cabinet-btn primary"
              onClick={() => handleSend()}
              disabled={loading || !prompt.trim()}
            >
              Спросить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
